<template>
  <a-form :form="form">
    <a-row :gutter="16">
      <a-col :xs="{span: 24}" :lg="{span:12}">
        <a-spin
          :spinning="anggaran.loadingtree"
          tip="Preparing to show Budget Code ...  "
        >
          <a-form-item label="Detail Option" v-if="isHRD && !isSecurity && isRecap">
            <a-radio-group ref="opt_dtl" button-style="solid"
            @change="changeOptdtl"
            v-decorator="['option_dtl', {rules: [{required: true}], initialValue:'umum'}]"
            >
              <!-- <a-radio-button value="umum">
                Reguler Item
              </a-radio-button> -->
              <a-radio-button value="kesehatan">
                Medical Claim
              </a-radio-button>
              <a-radio-button value="lkpd">
                LKPD
              </a-radio-button>
              <a-radio-button value="tiket">
                Ticket Claim 
              </a-radio-button>
            </a-radio-group>
          </a-form-item>
          <a-form-item  label="Budget Code">
            <a-tree-select
              v-decorator="['kode_anggaran', {rules: [{required: true}]}]"
              show-search
              style="width: 100%"
              @select="handlechoiceCost"
              :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
              :tree-data="anggaran.tree"
              treeNodeFilterProp="children"
              :filterTreeNode="filterTreeNode"
              placeholder="Please select"
              allow-clear
              :disabled="anggaran.loadingtree"
              tree-default-expand-all
            >
              <span slot="title" slot-scope="item">
                <table style="width:100%">
                  <tr>
                    <td>
                      <span> {{item.texttitle}} - {{item.kode_anggaran}}</span>
                    </td>
                    <td>
                      <span style="float:right"> {{formatRupiah(parseFloat(item.rekap))}} </span>
                    </td>
                  </tr>
                </table>
              </span>
              <template #suffixIcon><a-icon 
                  :type="anggaran.loadingtree ?  'loading' : 'down'" />
              </template>
            </a-tree-select>
          </a-form-item>
          <a-form-item label="Medical Claim Recapitulation" v-if="(isHRD && !isSecurity && isRecap) && $refs.opt_dtl && $refs.opt_dtl.value=='kesehatan' ">
            <a-select v-decorator="['medical_claim_id', { rules: [{ required: true }], initialValue: null, },]" 
              :loading="option.loading" 
              :disabled="option.loading"
              @change="changeMedicalClaimId"
              >
              <a-select-option v-for="el in option.rekap_kesehatan" :key="el.id_rekap" :disabled="el.disabled">
                {{ el.no_rekap }} | {{ el.description }} @{{ formatCurrency('IDR', el.total_value) }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="LKPD Recapitulation" v-else-if="(isHRD && !isSecurity && isRecap) && $refs.opt_dtl && $refs.opt_dtl.value=='lkpd'">
            <a-select v-decorator="['lkpd_id', { rules: [{ required: true }], initialValue: null, },]"
              :loading="option.loading" 
              :disabled="option.loading"
              @change="changeLkpdId"
            >
              <a-select-option v-for="el in option.rekap_lkpd" :key="el.id_rekap" :disabled="el.disabled">{{ el.no_rekap }} | {{ el.description }} @{{ formatCurrency('IDR', el.total_value) }}</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="Ticket Claim Recapitulation" v-else-if="(isHRD && !isSecurity && isRecap) && $refs.opt_dtl && $refs.opt_dtl.value=='tiket'">
            <a-select v-decorator="['ticket_id', { rules: [{ required: true }], initialValue: null, },]"
              :loading="option.loading" 
              :disabled="option.loading"
              @change="changeRekapTiket"
            >
              <a-select-option v-for="el in option.rekap_tiket" :key="el.id_rekap" :disabled="el.disabled">{{ el.no_rekap }} | {{ el.description }} @{{ formatCurrency('IDR', el.total_value) }}</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="Item Name" v-else>
            <a-input autocomplete="off" v-decorator="['nama_barang', {rules: [{required: !(isHRD && !isSecurity && isRecap) ? true : false}]}]"></a-input>
          </a-form-item>
          <a-row :gutter="8">
            <a-col :span="12">
              <a-form-item label="Quantity">
                <a-input-number
                  :max="10000"
                  :min="1"
                  @change="convertingqty"
                  class="m-width-full"
                  v-decorator="['jumlah', {rules: [{required: true}], initialValue:'1'}]"
                  :disabled="isOptionkesehatanorlkpd"
                ></a-input-number>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="Unit">
              <a-select
              showSearch
              @change="handleSatuan"
              v-decorator="['satuan', {rules: [{required: true}]}]"
              :disabled="isOptionkesehatanorlkpd"
              >
              <a-select-option
              v-for="item in initialSatuan"
              :key="item"
              :value="item"
              >{{item}}</a-select-option>
              </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-form-item label="Unit Price">
            <a-input-number
              :min="0"
              @change="convertinghrg"
              class="m-width-full m-text-align-right"
              :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
              :parser="value => value.replace(/\\s?|(,*)/g, '')"
              v-decorator="['harga', {rules: [{required: true}]}]"
              :disabled="isOptionkesehatanorlkpd"
            />
          </a-form-item>
          <p v-if="mata_uang!=='IDR'" class="margin-bottom">Total value to IDR: {{convert_value}}<br/></p>
          <a-form-item>
            <template #label>
              <a-checkbox :defaultChecked="needBailoutFund" @change="onchangeNeedBailoutFund" :checked="needBailoutFund" >Need Bailout Fund (IDR)</a-checkbox>
            </template>
            <a-input-number
              v-if="needBailoutFund"
              :min="0"
              class="m-width-full m-text-align-right"
              :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
              :parser="value => value.replace(/\\s?|(,*)/g, '')"
              :disabled="(Number(informasi.bailout_transfer)>0 || informasi.bailout_transfer==null) || isOptionkesehatanorlkpd"
              v-decorator="['bailout_value', {rules: [{required: needBailoutFund? true : false}]}]"
            />
          </a-form-item>
          <a-form-item :wrapper-col="{ span: 24 }">
            <a-button @click="handleNewItemConfirm" block type="primary" html-type="submit">Add</a-button>
          </a-form-item>
        </a-spin>
      </a-col>
      <a-col :xs="{span: 24}" :lg="{span:12}">
        <a-collapse class="margin-top" activeKey="1">

          <a-collapse-panel key="1">
            <h4 slot="header" class="margin-remove">Purchase List</h4>
            <a-table v-if="!getScreen" :columns="columns" :dataSource="getCountWeb" :pagination="pagination" size="small" :scroll="{ x: 700}" bordered>
              <template slot="item_nm" slot-scope="item_nm">
                <a-tag><b>{{getOptionNm(item_nm.values.option_dtl)}}</b></a-tag><br/>
                <span>{{item_nm.kode_anggaran}}</span><br/>
                <b>{{item_nm.item_name}}</b>
              </template>
              <template slot="operation" slot-scope="index,item">
                <a-button-group v-if="item">
                  <a-button type="primary" @click="handleEditModal(item)"
                  :disabled="anggaran.loadingtree">
                    <a-icon type="edit"/>
                  </a-button>
                  <a-button :disabled="anggaran.loadingtree" type="danger" @click="handleRemoveConfirm(item.values)">
                    <a-icon type="close"/>
                  </a-button>
                </a-button-group>
              </template>
            </a-table>

            <a-list itemLayout="vertical" :dataSource="listPembelian" :pagination="pagination" v-else>
              <Empty v-if="listPembelian ? listPembelian.length<=0 : listPembelian"/>
              <a-list-item slot="renderItem" slot-scope="item">
                <a-list-item-meta>
                  <a-row slot="title" type="flex" justify="space-between">
                    <div>
                      <a-tag><b>{{getOptionNm(item.values.option_dtl)}}</b></a-tag><br/>
                      <a href="#">{{item.deskripsi}}</a>
                    </div>
                  </a-row>
                  <p slot="description">
                  <ul class="m-list-wrapper">
                  <h3 class="margin-remove" >{{item.values.nama_barang}}</h3>
                    <div class="m-display-flex space-between">
                      <span>{{item.values.jumlah}}&nbsp;{{item.values.satuan}}</span>
                      <div>
                        <h4
                                class="margin-remove m-text-align right"
                        >@ {{formatCurrency(mata_uang,item.values.harga)}}</h4>
                      </div>
                    </div>
                    <a-divider class="margin-small" />
                    <h4 class="margin-remove m-text-align right">{{formatCurrency(mata_uang,item.hargaTotal)}}</h4>
                    <div v-if="item.values.bailout_value && item.values.bailout_value>0">
                        <h4
                                class="margin-remove m-text-align right"
                        >Bailout @ {{formatCurrency('IDR',item.values.bailout_value)}}</h4>
                      </div>
                  </ul>
                  </p>
                </a-list-item-meta>

                <a-button-group>
                  <a-button type="primary" @click="handleEditModal(item)"
                    :disabled="anggaran.loadingtree">
                    <a-icon type="edit" />&nbsp;Edit
                  </a-button>
                  <a-button type="danger" @click="handleRemoveConfirm(item.values)">
                    <a-icon type="close" />&nbsp; Remove
                  </a-button>
                </a-button-group>
              </a-list-item>
            </a-list>

          </a-collapse-panel>
        </a-collapse>
        <div class="m-price-total">
          <div v-if="totalBailout>0">
            <span class="m-list-title">
                Total Bailout :
                {{
                  formatRupiah(totalBailout, "IDR" )
                }}
            </span>
            <a-divider class="margin-small" />
          </div>
          <a-statistic title="Grand Total" :value="formatCurrency(mata_uang,totalPrice)" class="m-text-align right" />
        </div>
      </a-col>
    </a-row>
    <a-modal v-model="editModal" :maskClosable="false" @cancel="handleClose" @ok="handleEditModal" :footer="null">
      <span slot="title">
        <a-icon type="reload" />&nbsp;Change
      </span>

      <a-form :form="modalForm">
        <a-form-item label="Detail Option" v-if="isHRD && !isSecurity && isRecap">
          <a-radio-group ref="opt_dtl_modal" button-style="solid"
          v-decorator="['option_dtl', {rules: [{required: true}], initialValue: editData.values.option_dtl}]"
          disabled
          >
            <!-- <a-radio-button value="umum">
              Reguler Item
            </a-radio-button> -->
            <a-radio-button value="kesehatan">
              Medical Claim
            </a-radio-button>
            <a-radio-button value="lkpd">
              LKPD
            </a-radio-button>
            <a-radio-button value="lkpd">
              Ticket Claim
            </a-radio-button>
          </a-radio-group>
        </a-form-item>
        <a-form-item  label="Budget Code">
          <a-tree-select
            v-decorator="['kode_anggaran', {rules: [{required: true}], initialValue: editData.values.id_anggaran}]"
            show-search
            style="width: 100%"
            @select="handlechoiceCostModal"
            :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
            :tree-data="anggaran.tree"
            treeNodeFilterProp="children"
            :filterTreeNode="filterTreeNode"
            placeholder="Please select"
            allow-clear
            tree-default-expand-all
          >
            <span slot="title" slot-scope="item">
              <table style="width:100%">
                <tr>
                  <td>
                    <span> {{item.texttitle}} - {{item.kode_anggaran}}</span>
                  </td>
                  <td>
                    <span style="float:right"> {{formatRupiah(parseFloat(item.rekap))}} </span>
                  </td>
                </tr>
              </table>
            </span>
          </a-tree-select>
        </a-form-item>
        <a-form-item label="Medical Claim Recapitulation" v-if="(isHRD && !isSecurity && isRecap) && editData.values.option_dtl=='kesehatan'">
          <a-select v-decorator="['medical_claim_id', { rules: [{ required: true }], initialValue: editData.values.medical_claim_id, },]" 
            :loading="option.loading"
            @change="changeModalMedicalClaimId"
            >
            <a-select-option v-for="el in option.rekap_kesehatan" :key="el.id_rekap" :disabled="el.disabled">
              {{ el.no_rekap }} | {{ el.description }}
            </a-select-option>
          </a-select>
        </a-form-item>
        
        <a-form-item label="LKPD Recapitulation" v-else-if="(isHRD && !isSecurity && isRecap) && editData.values.option_dtl=='lkpd'">
          <a-select v-decorator="['lkpd_id', { rules: [{ required: true }], initialValue: editData.values.lkpd_id, },]"
            :loading="option.loading"
          >
            <a-select-option v-for="el in option.rekap_lkpd" :key="el.id_rekap" :disabled="el.disabled">{{ el.no_rekap }} | {{ el.description }}</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="Ticket Claim Recapitulation" v-else-if="(isHRD && !isSecurity && isRecap) && editData.values.option_dtl=='tiket'">
          <a-select v-decorator="['ticket_id', { rules: [{ required: true }], initialValue: editData.values.ticket_id, },]"
          @change="changeModalTicketClaimId"  
          :loading="option.loading"
          >
            <a-select-option v-for="el in option.rekap_tiket" :key="el.id_rekap" :disabled="el.disabled">{{ el.no_rekap }} | {{ el.description }} @{{ formatCurrency('IDR', el.total_value) }}</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="Item Name" v-else>
          <a-input
            autocomplete="off"
            v-decorator="['nama_barang', {rules: [{required: !(isHRD && !isSecurity && isRecap) ? true : false}], initialValue: editData.values.nama_barang}]"
          ></a-input>
        </a-form-item>
        <a-row :gutter="8">
          <a-col :span="12">
            <a-form-item label="Quantity">
              <a-input-number
                :min="1"
                :max="10000"
                @change="convertingmodalqty"
                class="m-width-full"
                v-decorator="['jumlah', {rules: [{required: true}], initialValue: editData.values.jumlah}]"
                :disabled="editData.values.option_dtl!='umum'"
              ></a-input-number>
            </a-form-item>
          </a-col>


          <a-col :span="12">
            <a-form-item label="Unit">
              <a-select
                showSearch
                @change="handleSatuan"
                v-decorator="['satuan', {rules: [{required: true}], initialValue: editData.values.satuan}]"
                :disabled="editData.values.option_dtl!='umum'"
              >
                <a-select-option
                        v-for="item in initialSatuan"
                        :key="item"
                        :value="item"
                >{{item}}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-form-item label="Unit Price">
          <a-input-number
            class="m-width-full m-text-align-right"
            @change="convertingmodalhrg"
            :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
            :parser="value => value.replace(/\\s?|(,*)/g, '')"
            v-decorator="['harga', {rules: [{required: true}], initialValue: editData.values.harga}]"
            :disabled="editData.values.option_dtl!='umum'"
          />
        </a-form-item>
        <p v-if="mata_uang!=='IDR'" class="margin-bottom">Total value to IDR: {{modalconvert_value}}<br/></p>
        <a-form-item label="Bailout Value (IDR)">
          <a-input-number
            :min="0"
            class="m-width-full m-text-align-right"
            :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
            :parser="value => value.replace(/\\s?|(,*)/g, '')"
            :disabled="(Number(informasi.bailout_transfer)>0 || informasi.bailout_transfer==null) || editData.values.option_dtl!='umum'"
            v-decorator="['bailout_value', {rules: [{required: false}], initialValue: editData.values.bailout_value}]"
          />
        </a-form-item>
        <a-form-item :wrapper-col="{ span: 24 }">
          <a-button @click="handleModalEdit" block type="danger" html-type="submit">Change</a-button>
        </a-form-item>
      </a-form>
    </a-modal>
  </a-form>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import CurrencyFormat from "@/mixins/CurrencyFormat";

export default {
  name: "DetailPembelian",
  mixins: [CurrencyFormat],
  props: {
    listPembelian: {},
    informasi: {},
    infoUmum: {},
    keuangan: {},
    mode: String,
    mata_uang: String,
  },
  data() {
    return {
      editModal: false,
      pagination: {
        onChange: (page) => {},
        pageSize: 5,
        size: "small",
      },
      satuan: [],
      editData: [],
      anggaran: {
        modalvalue: undefined,
        path: "",
        limit: 0,
        old_modalvalue: undefined,
        old_path: "",
        old_limit: 0,
        tree: [],
        treeModal: [],
        searchValue: "",
        loadingtree: false,
      },
      convert_value: 0,
      modalconvert_value: 0,
      option:{
        rekap_kesehatan:[],
        rekap_lkpd:[],
        loading: false
      },
      isOptionkesehatanorlkpd: false,
      needBailoutFund: false
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
    this.modalForm = this.$form.createForm(this);
  },
  created() {
    this.getTreeAnggaran();
  },
  computed: {
    ...mapGetters(["getScreen", "getSatuan", "getAuth", "getBailoutValue"]),
    initialData() {
      if (this.listPembelian === undefined || this.listPembelian.length <= 0) {
        return {
          nama_barang: "",
          jumlah: 0,
          satuan: "",
          harga: 0,
          path: "",
          id_anggaran: "",
          kode_anggaran: "",
          kode_anggaran_dtl: "",
        };
      } else {
        return {
          nama_barang: this.listPembelian.nama_barang,
          jumlah: this.listPembelian.jumlah,
          satuan: this.listPembelian.satuan,
          harga: this.listPembelian.harga,
          path: this.listPembelian.path,
          id_anggaran: this.listPembelian.id_anggaran,
          kode_anggaran: this.listPembelian.kode_anggaran,
          kode_anggaran_dtl: this.listPembelian.kode_anggaran_dtl,
        };
      }
    },
    initialList() {
      let outputList = [];
      if (this.listPembelian.length >= 1) {
        outputList = this.listPembelian;
      }

      return outputList;
    },
    totalPrice() {
      let total = 0;
      this.listPembelian.forEach((item) => {
        total = total + item.hargaTotal;
      });

      return total;
    },
    totalBailout() {
      let total = 0;
      this.listPembelian.forEach((item) => {
        total = total + Number(item.values.bailout_value);
      });

      return total;
    },
    initialSatuan() {
      let satuan = [];
      this.getSatuan.forEach((item) => {
        satuan.push(item["id"]);
      });

      return satuan;
    },
    columns() {
      const kolom = [
        {
          title: "No",
          dataIndex: "no",
          key: "no",
          width: 60,
          sorter: (a, b) => a.no - b.no,
          fixed: "left",
        },
        {
          title: "Item Name",
          //dataIndex: "item_name",
          scopedSlots: { customRender: "item_nm" },
          width: 200,
          key: "item_name",
          sorter: (a, b) => a.item_name.length - b.item_name.length,
        },
        {
          title: "Quantity",
          dataIndex: "quantity",
          key: "quantity",
          width: 100,
          sorter: (a, b) => a.quantity.length - b.quantity.length,
        },
        {
          title: "Unit Price",
          dataIndex: "unit_price",
          key: "unit_price",
          width: 100,
          align: 'right'
        },
        {
          title: "Amount",
          dataIndex: "amount",
          key: "amount",
          width: 100,
          align: 'right'
        },
        {
          title: "Bailout Value",
          dataIndex: "bailout",
          key: "bailout",
          width: 100,
          align: 'right'
        },
        {
          title: "Action",
          dataIndex: "operation",
          scopedSlots: { customRender: "operation" },
          width: 110,
          fixed: "right",
        },
      ];
      return kolom;
    },
    getCountWeb() {
      let data = this.listPembelian;
      if (data) {
        data.forEach((value, index) => {
          data[index]["path"] = value.values.path;
          data[index]["kode_anggaran"] = value.values.kode_anggaran;
          data[index]["kode_anggaran_dtl"] = value.values.kode_anggaran_dtl;
          data[index]["pemakaian"] = value.values.pemakaian;
          data[index]["id_anggaran"] = value.values.id_anggaran;
          data[index]["item_name"] = value.values.nama_barang;
          data[index]["amount"] = this.formatCurrency(
            this.mata_uang,
            value.hargaTotal
          );
          data[index]["quantity"] =
            value.values.jumlah + " " + value.values.satuan;
          data[index]["unit_price"] = this.formatCurrency(
            this.mata_uang,
            value.values.harga
          );
          data[index]["bailout"] = this.formatCurrency(
            'IDR',
            (value.values.bailout_value ? value.values.bailout_value : 0)
          );
          data[index]["bailout_transfer"] = value.values.bailout_transfer ? Number(value.values.bailout_transfer) : 0;
          data[index]["no"] = index + 1;
          data[index]["key"] = index + 1;
        });
      }
      return data;
    },
    isHRD(){
      let res = false
      this.getAuth.divisi.forEach(element => {
        if(element.toLowerCase()=='hrd'){
          res = true
        }
      });
      return res
    },
    isSecurity(){
      let res = false
      this.getAuth.nama_bidang.forEach(element => {
        if(element.toLowerCase()=='security'){
          res = true
        }
      });
      return res
    },
    isRecap(){
      return this.informasi.used_for=='6' ? true : false
    }
  },
  methods: {
    convertingqty(val) {
      let vinput = this.form.getFieldsValue();
      let tot =
        (val ? val : vinput.jumlah) * vinput.harga * this.keuangan.kurs_to_idr;
      this.convert_value = this.formatRupiah(isNaN(tot) ? 0 : tot);
    },
    convertinghrg(val) {
      let vinput = this.form.getFieldsValue();
      let tot =
        vinput.jumlah * (val ? val : vinput.harga) * this.keuangan.kurs_to_idr;
      this.convert_value = this.formatRupiah(isNaN(tot) ? 0 : tot);
    },
    convertingmodalqty(val) {
      let vinput = this.modalForm.getFieldsValue();
      let tot =
        (val ? val : vinput.jumlah) * vinput.harga * this.keuangan.kurs_to_idr;
      this.modalconvert_value = this.formatRupiah(isNaN(tot) ? 0 : tot);
    },
    convertingmodalhrg(val) {
      let vinput = this.modalForm.getFieldsValue();
      let tot =
        vinput.jumlah * (val ? val : vinput.harga) * this.keuangan.kurs_to_idr;
      this.modalconvert_value = this.formatRupiah(isNaN(tot) ? 0 : tot);
    },
    handleClose() {
      this.convert_value = 0;
      this.modalForm.resetFields();

      if(this.listPembelian.length>0){
        this.listPembelian.forEach(element => {
          if(this.editData.values.medical_claim_id && element.values.medical_claim_id){
            let idx = this.option.rekap_kesehatan.findIndex(item => item.id_rekap == this.editData.values.medical_claim_id)
            if(idx>=0)
              this.option.rekap_kesehatan[idx].disabled = true
          }
          if(this.editData.values.lkpd_id && element.values.lkpd_id){
            let idx = this.option.rekap_lkpd.findIndex(item => item.lkpd_id == this.editData.values.lkpd_id)
            if(idx>=0)
              this.option.rekap_lkpd[idx].disabled = true
          }
        });
      }

      this.recountingAnggaran(this.listPembelian);
    },
    async getApproval(anggaran_id) {
      return await axios({
        method: "post",
        url: this.$serviceUrl + "pp/approval_pp",
        data: {
          tlc: this.getAuth.username,
          anggaran_dtl_val_id: anggaran_id,
          anggaran_dtl_list: this.listPembelian,
          mode: this.mode,
          id_pp: this.infoUmum ? this.infoUmum.id_pp : null,
          end_user: this.informasi.end_user,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      });
    },
    getTreeAnggaran() {
      this.anggaran.loadingtree = true;
      let dataParams =
        this.mode == "Edit"
          ? {
              anggaran_id: this.informasi.cost_center,
              tlc: this.getAuth.username,
              peruntukan_id: this.informasi.peruntukan,
              id_pp: this.infoUmum.id_pp,
            }
          : {
              anggaran_id: this.informasi.cost_center,
              tlc: this.getAuth.username,
              peruntukan_id: this.informasi.peruntukan,
            };
      axios({
        method: "get",
        url: this.$serviceUrl + "pp/tree_anggaran",
        params: dataParams,
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.anggaran.tree = response.data.tree;
          this.anggaran.treeModal = [
            ...this.anggaran.treeModal,
            response.data.tree[0],
          ];
          this.recountingAnggaran(this.listPembelian);
          this.anggaran.loadingtree = false;
        })
        .catch((err) => {
          console.log("err", err);
          this.anggaran.loadingtree = false;
          let responses = Object.assign({}, err.response);
          this.displayMessageValue("error", responses);
        });
    },
    handlechoiceCost(value, record) {
      this.anggaran.limit = record.dataRef.rekap;
      this.anggaran.path = record.dataRef.path;
    },
    handlechoiceCostModal(value, record) {
      //untuk mengisi old value jika tidak lolos validasi maka value dikembalikan ke old value
      this.anggaran.old_limit = this.anggaran.limit;
      this.anggaran.old_path = this.anggaran.path;
      this.anggaran.old_modalvalue = this.anggaran.modalvalue;

      this.anggaran.limit = record.dataRef.rekap;
      this.anggaran.path = record.dataRef.path;
      this.anggaran.modalvalue = value;
    },
    filterTreeNode(input, option) {
      return (
        option.data.props.texttitle == undefined ||
        (option.data.props.texttitle ? option.data.props.texttitle : "")
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0 ||
        (option.data.props.kode_anggaran ? option.data.props.kode_anggaran : "")
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    handleSatuan(input, option) {
      return (
        option.componentOptions.children[0].text
          .toUpperCase()
          .indexOf(input.toUpperCase()) >= 0
      );
    },
    handleRef() {
      if (this.listPembelian.length <= 0) {
        this.displayMessage("form-moreData");
      } else {
        if (this.mode == "Edit") {
          this.getApproval(this.listPembelian[0].values.kode_anggaran_dtl)
            .then((res) => {
              Event.$emit("ppData", {
                estimated_value: this.totalPrice,
                approval: res.data.approval,
              });
            })
            .catch((err) => {
              if (err.response) {
                this.$notification.error({
                  message: "Error Message",
                  description: err.response.data.message,
                });
              }
              return err;
            });
          // Event.$emit("ppData", {
          //   estimated_value: this.totalPrice
          // });
        } else {
          this.getApproval(this.listPembelian[0].values.kode_anggaran_dtl)
            .then((res) => {
              Event.$emit("ppData", {
                estimated_value: this.totalPrice,
                approval: res.data.approval,
              });
            })
            .catch((err) => {
              if (err.response) {
                this.$notification.error({
                  message: "Error Message",
                  description: err.response.data.message,
                });
              }
              return err;
            });
        }
      }
    },
    handleNewItemConfirm() {
      this.confirmMessageValue("confirm-add-detil", true);
    },
    handleNewItem() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }
        const findName = this.listPembelian.filter(
          (item) =>
            item.values.nama_barang + item.values.id_anggaran ===
            values.nama_barang + values.kode_anggaran
        );

        let ObjVal = this.anggaran.path.split(";");
        let path = "";
        ObjVal.forEach((element) => {
          if (path == "") {
            path += "tempTree[" + element + "]";
          } else {
            path += ".children[" + element + "]";
          }
        });

        let tempTree = this.anggaran.tree;
        let limitasi = eval(path + ".rekap");
        let kdanggrn = eval(path + ".kode_anggaran");
        let kdanggrn2 = eval(path + ".value");
        kdanggrn2 = kdanggrn2.split(";");
        let vldLimit =
          parseFloat(limitasi) <
          values.jumlah * values.harga * this.keuangan.kurs_to_idr;

        if(values.bailout_value && values.bailout_value>(values.harga*values.jumlah)){
          this.displayMessageValue(
            "error-other",
            "Bailout value is over then value detail!"
          );
          return
        }
        if(values.bailout_value && ((this.totalBailout+values.bailout_value)>this.getBailoutValue)){
          this.displayMessageValue(
            "error-other",
            "value is over limit of max. bailout value ("+this.formatRupiah(this.getBailoutValue)+")"
          );
          return
        }

        if (findName.length > 0) {
          this.displayMessage("form-duplicate");
          return;
        } else if (vldLimit) {
          this.displayMessageValue(
            "limit-anggaran",
            this.formatRupiah(limitasi)
          );
          return;
        } else {
          if(values.medical_claim_id){
            this.option.rekap_kesehatan.forEach(element => {
              if(element.id_rekap==values.medical_claim_id){
                values['nama_barang'] = element.no_rekap+" | "+ element.description
                element.disabled = true
              }
            });
          }else if(values.lkpd_id){
            this.option.rekap_lkpd.forEach(element => {
              if(element.id_rekap==values.lkpd_id){
                values['nama_barang'] = element.no_rekap+" | "+ element.description
                element.disabled = true
              }
            });
          }else if(values.ticket_id){
            this.option.rekap_tiket.forEach(element => {
              if(element.id_rekap==values.ticket_id){
                values['nama_barang'] = element.no_rekap+" | "+ element.description
                element.disabled = true
              }
            });
          }
          
          //replace pengurangan value pada tree
          let hargaTotal = values.jumlah * values.harga;
          // path+=".rekap="+ (limitasi-hargaTotal)
          // eval(path)
          // this.anggaran.tree = tempTree
          //-

          values.path = this.anggaran.path;
          values.id_anggaran = values.kode_anggaran;
          values.kode_anggaran = kdanggrn;
          values.kode_anggaran_dtl = kdanggrn2[kdanggrn2.length - 1];
          values.oldvalue = limitasi;
          values.pemakaian = 0;
          Event.$emit("listPembelian", { values, hargaTotal });

          this.form.resetFields();
          this.isOptionkesehatanorlkpd = false;
          this.convert_value = 0;
          //this.anggaran.valu = undefined
        }
      });
    },
    handleRemoveConfirm(item) {
      if(Number(item.bailout_value)>0 && item.bailout_transfer!='1'){
        this.displayMessageValue(
            "error-other",
            "Can't be delete cause Bailout value has been transfered!"
          );
        return
      }
      this.confirmMessageValue("confirm-delete-detil", item);
    },
    handleRemove(item) {
      if (item.pemakaian == "0" || this.informasi.used_for == "3") {
        const dataItem = item.nama_barang + item.id_anggaran;

        const newPush = this.listPembelian.filter(
          (item) => item.values.nama_barang + item.id_anggaran !== dataItem
        );

        //kembalikan value limitasi anggaran pada tree kode anggaran
        let ObjVal = item.path.split(";");
        let path = "";
        ObjVal.forEach((element) => {
          if (path == "") {
            path += "tempTree[" + element + "]";
          } else {
            path += ".children[" + element + "]";
          }
        });
        let tempTree = this.anggaran.tree;
        let oldVal = eval(path + ".rekap");
        let value_tree =
          oldVal + item.jumlah * item.harga * this.keuangan.kurs_to_idr;
        let exe1 = path + ".rekap=" + value_tree;
        eval(exe1);
        if (value_tree <= 0) {
          eval(path + ".disabled=true");
        } else {
          eval(path + ".disabled=false");
        }
        this.anggaran.tree = tempTree;

        if(item.medical_claim_id){
            this.option.rekap_kesehatan.forEach(element => {
              if(element.id_rekap==item.medical_claim_id){
                element.disabled = false
              }
            });
          }else if(item.lkpd_id){
            this.option.rekap_lkpd.forEach(element => {
              if(element.id_rekap==item.lkpd_id){
                element.disabled = false
              }
            });
          }

        Event.$emit("updateList", newPush);
      } else {
        this.displayMessage("error-delete-dtl");
      }
    },
    recountingAnggaran(arr) {
      // console.log("arr", arr);
      if (arr.length > 0) {
        //restore nominal ke origin
        arr.forEach((elm) => {
          let ObjVal = elm.values.path.split(";");
          let path1 = "";
          let path2 = "";
          ObjVal.forEach((element) => {
            if (path1 == "") {
              path1 += "tempTree[" + element + "]";
            } else {
              path1 += ".children[" + element + "]";
            }
          });
          let tempTree = this.anggaran.tree;
          path2 = eval(path1 + ".origin_rekap");
          eval(path1 + ".rekap=" + path2);
        });
        //menghitung nominal dengan acuan nominal origin
        arr.forEach((elem) => {
          let ObjVal = elem.values.path.split(";");
          let path = "";
          ObjVal.forEach((element) => {
            if (path == "") {
              path += "tempTree[" + element + "]";
            } else {
              path += ".children[" + element + "]";
            }
          });
          let tempTree = this.anggaran.tree;
          let oldVal = eval(path + ".rekap");
          let value_tree =
            oldVal -
            elem.values.harga * elem.values.jumlah * this.keuangan.kurs_to_idr;
          let exe1 = path + ".rekap=" + value_tree;
          eval(exe1);
          if (value_tree <= 0) {
            eval(path + ".disabled=true");
          } else {
            eval(path + ".disabled=false");
          }
          this.anggaran.tree = tempTree;
        });
      }
    },
    handleEditModal(item) {
    
      this.editData = item;
      this.anggaran.modalvalue = item.id_anggaran;
      this.anggaran.path = item.path;

      this.anggaran.old_modalvalue = item.id_anggaran;
      this.anggaran.old_path = item.path;

      //set limit ditambah dengan nilai value yg diedit
      let ObjVal = this.anggaran.path.split(";");
      let path = "";
      ObjVal.forEach((element) => {
        if (path == "") {
          path += "tempTree[" + element + "]";
        } else {
          path += ".children[" + element + "]";
        }
      });

      let tempTree = this.anggaran.tree;
      let limitasi = eval(path + ".rekap");
      let valrekap =
        parseFloat(limitasi) +
        parseFloat(this.editData.hargaTotal * this.keuangan.kurs_to_idr);
      eval(path + ".rekap=" + valrekap);
      if (valrekap <= 0) {
        eval(path + ".disabled=true");
      } else {
        eval(path + ".disabled=false");
      }

      let tot =
        this.editData.values.jumlah *
        this.editData.values.harga *
        this.keuangan.kurs_to_idr;
      this.modalconvert_value = this.formatRupiah(isNaN(tot) ? 0 : tot);

      if(this.listPembelian.length>0){
        this.listPembelian.forEach(element => {
          if(this.editData.values.medical_claim_id && element.values.medical_claim_id){
            let idx = this.option.rekap_kesehatan.findIndex(item => item.id_rekap == this.editData.values.medical_claim_id)
            if(idx>=0)
              this.option.rekap_kesehatan[idx].disabled = false
          }
          if(this.editData.values.lkpd_id && element.values.lkpd_id){
            let idx = this.option.rekap_lkpd.findIndex(item => item.lkpd_id == this.editData.values.lkpd_id)
            if(idx>=0)
              this.option.rekap_lkpd[idx].disabled = false
          }
          if(this.editData.values.tiket_id && element.values.tiket_id){
            let idx = this.option.rekap_tiket.findIndex(item => item.tiket_id == this.editData.values.tiket_id)
            if(idx>=0)
              this.option.rekap_tiket[idx].disabled = false
          } 
        });
      }

      this.editModal = !this.editModal;
    },
    handleModalEdit() {
      this.modalForm.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }

        if(values.bailout_value && values.bailout_value>(values.harga*values.jumlah)){
          this.displayMessageValue(
            "error-other",
            "Bailout value is over then value detail!"
          );
          return
        }
        if(values.bailout_value && 
          ((this.totalBailout -
            (this.editData.values.bailout_value*Number(this.editData.values.jumlah)) +
            values.bailout_value) >this.getBailoutValue)){
          this.displayMessageValue(
            "error-other",
            "value is over limit of max. bailout value ("+this.formatRupiah(this.getBailoutValue)+")"
          );
          return
        }

        //console.log("modaledit")
        //validasi item double
        const findName = this.listPembelian.filter(
          (item) =>
            item.item_name === values.nama_barang &&
            item.id_anggaran == values.kode_anggaran
        );
        const findName2 = this.listPembelian.filter(
          (item) => item.key === this.editData.key
        );

        //validasi limit value
        let ObjVal = this.anggaran.path.split(";");
        let path = "";
        ObjVal.forEach((element) => {
          if (path == "") {
            path += "tempTree[" + element + "]";
          } else {
            path += ".children[" + element + "]";
          }
        });

        let tempTree = this.anggaran.tree;
        let limitasi = eval(path + ".rekap");
        let kdanggrn = eval(path + ".kode_anggaran");
        let kdanggrn2 = eval(path + ".value");
        kdanggrn2 = kdanggrn2.split(";");
        let vldLimit =
          parseFloat(limitasi) <
          values.jumlah * values.harga * this.keuangan.kurs_to_idr;

        //validasi batas bawah nilai pemakaian
        // let batasBawah = 0
        // if (this.mode=="Edit"){
        //   batasBawah = parseFloat(eval(path+".pemakaian"))
        // }

        let fkey = findName[0] ? findName[0].key : "";
        let fpemakaian = findName2[0] ? parseFloat(findName2[0].pemakaian) : 0;
        //console.log("ketahui",values,values.jumlah,values.harga,this.keuangan.kurs_to_idr)

        if (findName.length > 0 && fkey !== this.editData.key) {
          this.displayMessage("form-duplicate");

          let tot =
            this.editData.values.jumlah *
            this.editData.values.harga *
            this.keuangan.kurs_to_idr;
          this.modalconvert_value = this.formatRupiah(isNaN(tot) ? 0 : tot);
          this.anggaran.limit = this.anggaran.old_limit;
          this.anggaran.path = this.anggaran.old_path;
          this.anggaran.modalvalue = this.anggaran.old_modalvalue;
          return;
        } else if (vldLimit) {
          this.displayMessageValue(
            "limit-anggaran",
            this.formatRupiah(parseFloat(limitasi))
          );

          let tot =
            this.editData.values.jumlah *
            this.editData.values.harga *
            this.keuangan.kurs_to_idr;
          this.modalconvert_value = this.formatRupiah(isNaN(tot) ? 0 : tot);
          this.anggaran.limit = this.anggaran.old_limit;
          this.anggaran.path = this.anggaran.old_path;
          this.anggaran.modalvalue = this.anggaran.old_modalvalue;
          return;
          // } else if(this.mode=="Edit" && (values.jumlah * values.harga* this.keuangan.kurs_to_idr)>batasBawah){

          //  this.displayMessageValue("limit-bawah-anggaran",this.formatRupiah(batasBawah))

          //   let tot = this.editData.values.jumlah * this.editData.values.harga * this.keuangan.kurs_to_idr
          //   this.modalconvert_value = this.formatRupiah(isNaN(tot) ? 0 : tot)
          //   return;
        } else if (
          this.mode == "Edit" &&
          parseFloat(fpemakaian) > values.jumlah * values.harga
        ) {
          this.displayMessageValue(
            "limit-pemakaian-anggaran",
            this.formatRupiah(fpemakaian * this.keuangan.kurs_to_idr)
          );

          let tot =
            this.editData.values.jumlah *
            this.editData.values.harga *
            this.keuangan.kurs_to_idr;
          this.modalconvert_value = this.formatRupiah(isNaN(tot) ? 0 : tot);
          this.anggaran.limit = this.anggaran.old_limit;
          this.anggaran.path = this.anggaran.old_path;
          this.anggaran.modalvalue = this.anggaran.old_modalvalue;
          return;
        } else {
          const dataItem =
            this.editData.values.nama_barang + this.editData.values.id_anggaran;
          const newPush = this.listPembelian.filter(
            (item) =>
              item.values.nama_barang + item.values.id_anggaran !== dataItem
          );
          const existPush = this.listPembelian.filter(
            (item) =>
              item.values.nama_barang + item.values.id_anggaran == dataItem
          );
          Event.$emit("updateList", newPush);
          //this.handleRemove(this.editData.values);
          if (this.mode == "Edit" && existPush.length > 0) {
            values.pemakaian = existPush[0].pemakaian;
          } else {
            values.pemakaian = 0;
          }
          values.path = this.anggaran.path;
          values.id_anggaran = this.anggaran.modalvalue;
          values.kode_anggaran = kdanggrn;
          values.kode_anggaran_dtl = kdanggrn2[kdanggrn2.length - 1];
          let hargaTotal = values.jumlah * values.harga;
          values.oldvalue = limitasi;
          if (this.mode == "Edit" && this.editData.values.id_pp_dtl) {
            values.id_pp_dtl = this.editData.values.id_pp_dtl;
          }

          if(values.medical_claim_id){
            this.option.rekap_kesehatan.forEach(element => {
              if(element.id_rekap==values.medical_claim_id){
                values['nama_barang'] = element.no_rekap+" | "+ element.description
                element.disabled = true
              }
            });
          }else if(values.lkpd_id){
            this.option.rekap_lkpd.forEach(element => {
              if(element.id_rekap==values.lkpd_id){
                values['nama_barang'] = element.no_rekap+" | "+ element.description
                element.disabled = true
              }
            });
          }else if(values.ticket_id){
            this.option.rekap_tiket.forEach(element => {
              if(element.id_rekap==values.ticket_id){
                values['nama_barang'] = element.no_rekap+" | "+ element.description
                element.disabled = true
              }
            });
          }
          
          Event.$emit("listPembelian", { values, hargaTotal });
          this.editModal = !this.editModal;
          this.modalconvert_value = 0;
        }
      });

      this.modalForm.resetFields();
    },
    async getOptionList() {
      this.option.loading = true
      await axios({
        method: "get",
        url: this.$serviceUrl + "pp/rekap",
        params:{
          id_pp: this.infoUmum ? this.infoUmum.id_pp : null,
          cost_center: this.informasi.cost_center_text
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      }).then((res)=>{
        this.option.rekap_kesehatan = res.data.rekap_kesehatan
        this.option.rekap_kesehatan.forEach(element => {
          element['disabled'] = false
        });

        this.option.rekap_lkpd = res.data.rekap_lkpd
        this.option.rekap_lkpd.forEach(element => {
          element['disabled'] = false
        });

        this.option.rekap_tiket = res.data.rekap_tiket
        this.option.rekap_tiket.forEach(element => {
          element['disabled'] = false
        });

        if(this.listPembelian.length>0){
          this.listPembelian.forEach(element => {
            if(element.values.medical_claim_id){
              let idx = this.option.rekap_kesehatan.findIndex(item => item.id_rekap == element.values.medical_claim_id)
              if(idx>=0)
                this.option.rekap_kesehatan[idx].disabled = true
            }
            if(element.values.lkpd_id){
              let idx = this.option.rekap_lkpd.findIndex(item => item.id_rekap == element.values.lkpd_id)
              if(idx>=0)
                this.option.rekap_lkpd[idx].disabled = true
            }
          });
        }
        this.option.loading = false
      });
    },
    changeOptdtl(val){
      this.isOptionkesehatanorlkpd = (val.target.value!='umum' ? true : false)
      this.resetChangelkpdmcd()
    },
    changeMedicalClaimId(val){
      if(val){
        let temp = this.option.rekap_kesehatan.filter(item => item.id_rekap==val)
        this.$nextTick(function () {
          this.form.setFieldsValue({
            jumlah: 1,
            satuan: 'Paket',
            harga: temp[0].total_value,
            bailout_value: null
          });
        }); 
      }
    },
    changeModalMedicalClaimId(val){
      if(val){
        let temp = this.option.rekap_kesehatan.filter(item => item.id_rekap==val)
        this.$nextTick(function () {
          this.modalForm.setFieldsValue({
            jumlah: 1,
            satuan: 'Paket',
            harga: temp[0].total_value,
            bailout_value: null
          });
        }); 
      }
    },

    changeModalTicketClaimId(val){
      if(val){
        let temp = this.option.rekap_tiket.filter(item => item.id_rekap==val)
        this.$nextTick(function () {
          this.modalForm.setFieldsValue({
            jumlah: 1,
            satuan: 'Paket',
            harga: temp[0].total_value,
            bailout_value: null
          });
        }); 
      }
    },
    changeLkpdId(val){
      if(val){
        let temp = this.option.rekap_lkpd.filter(item => item.id_rekap==val)
        this.$nextTick(function () {
          this.form.setFieldsValue({
            jumlah: 1,
            satuan: 'Paket',
            harga: temp[0].total_value,
            bailout_value: null
          });
        }); 
      }
    },
    changeRekapTiket(val){
      if(val){
        let temp = this.option.rekap_tiket.filter(item => item.id_rekap==val)
        this.$nextTick(function () {
          this.form.setFieldsValue({
            jumlah: 1,
            satuan: 'Paket',
            harga: temp[0].total_value,
            bailout_value: null
          });
        }); 
      }
    },
    resetChangelkpdmcd(){
      this.$nextTick(function () {
          this.form.setFieldsValue({
            jumlah: 1,
            satuan: null,
            harga: null,
            bailout_value: null
          });
        }); 
    },
    getOptionNm(val){
      let res = 'REGULER ITEM'
      if(val=='kesehatan'){
        res = 'MEDICAL CLAIM'
      }else if(val=='lkpd'){
        res = 'LKPD'
      }else if(val=='tiket'){
        res = 'TICKET CLAIM'
      }
      return res
    },
    onchangeNeedBailoutFund(val){
      this.needBailoutFund = val.target.checked
    }
  },
  mounted() {
    Event.$on("confirmMessageAddDetil", this.handleNewItem);
    Event.$on("confirmMessageDeleteDetil", this.handleRemove);
    this.getOptionList()
  },
  beforeDestroy() {
    Event.$off("confirmMessageAddDetil", this.handleNewItem);
    Event.$off("confirmMessageDeleteDetil", this.handleRemove);
  },
};
</script>

<style>
</style>